import { render, staticRenderFns } from "./LocationMap.vue?vue&type=template&id=28ef7c58&scoped=true"
import script from "./LocationMap.vue?vue&type=script&lang=js"
export * from "./LocationMap.vue?vue&type=script&lang=js"
import style0 from "./LocationMap.vue?vue&type=style&index=0&id=28ef7c58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ef7c58",
  null
  
)

export default component.exports